const allFlatpickrsClosed = () =>
  document.querySelector(".flatpickr-calendar.open") == null;

// Users are clicking from "start" to "end" inputs directly -
// while the "start" flatpickr is still open
//
// As such we refresh the visit/schedule-rule form when _all_
// flatpickrs are closed (as refreshing while one is open, unbinds
// the input field from the second open flatpickr)
export const flatpickrClosedHook = (el) => {
  setTimeout(() => {
    if (allFlatpickrsClosed()) {
      const allClosedEvent = new Event("flatpickr:onAllClosed");
      el.dispatchEvent(allClosedEvent);
    }
  }, 200);
};
